import {useMutation} from "@tanstack/react-query";
import {exportProductExcelIn} from "../../../../../api/product/ProductInApi";
import {ProductInSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";

export const useExportProductExcelIn = () => {
    const {mutate} = useMutation({
        mutationFn: (data: ProductInSearchParamType) => exportProductExcelIn(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `제품_목록_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
